import propEq from "ramda/src/propEq";

export const pathStatusEq = propEq("status");
